import * as React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

export default function SuggestedFlowers({ flowers }) {
  React.useEffect(() => {
    const fixTabletSpacing = () => {
      const swiper = document.querySelector(".suggested-flowers");
      if (swiper) {
        const width = window.innerWidth;
        if (width >= 1024 && width < 1280) {
          swiper.style.marginTop = "-5rem";
          swiper.style.marginBottom = "-5rem";
        } else {
          swiper.style.marginTop = "0";
          swiper.style.marginBottom = "0";
        }
      }
    };

    fixTabletSpacing();
    window.addEventListener("resize", fixTabletSpacing);
    return () => window.removeEventListener("resize", fixTabletSpacing);
  }, []);

  if (!flowers?.nodes?.length) return null;

  return (
    <section className="suggested-flowers w-full">
      <Swiper
        autoHeight={true}
        centeredSlides={false}
        breakpoints={{
          300: { slidesPerView: 1.6, spaceBetween: 5 },
          768: { slidesPerView: 3, spaceBetween: 10 },
          1024: { slidesPerView: 3, spaceBetween: 32 },
          1280: { slidesPerView: 3, spaceBetween: 40 },
        }}
        className="!overflow-visible !pt-0 !pb-0"
      >
        {flowers.nodes.map((flower) => {
          const image = flower.featuredImage?.node?.gatsbyImage;
          if (!image) return null;

          return (
            <SwiperSlide
              key={flower.slug}
              className="group flex flex-col items-center !h-auto"
            >
              <Link
                to={`/flower/${flower.slug}`}
                className="flex flex-col items-center w-full transition-transform duration-300 ease-out hover:scale-105"
                draggable={false}
                onContextMenu={(e) => e.preventDefault()}
              >
                <div className="w-full flex justify-center items-end mb-4 lg:-mb-5 xl:mb-4 h-[280px] md:h-[300px] lg:h-[340px] xl:h-[360px]">
                  <GatsbyImage
                    image={image}
                    alt={flower.title}
                    className="object-contain w-full h-full"
                    imgStyle={{ objectFit: "contain" }}
                    draggable={false}
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </div>
                <div className="w-full text-center min-h-[32px] flex items-center justify-center">
                  <h3 className="xl:hidden uppercase text-sm tracking-wide text-charcoal font-normal">
                    {flower.title}
                  </h3>
                  <h3 className="hidden xl:block uppercase text-sm tracking-wide text-charcoal font-normal opacity-0 group-hover:opacity-100 underline underline-offset-4 decoration-1 transition-opacity duration-300">
                    {flower.title}
                  </h3>
                </div>
              </Link>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
}
